import { useState } from 'react';
import ModalInfo from 'components/templates/modalInfo/ModalInfo';
import SearchInput from 'components/commons/inputs/SearchInput/SearchInput';
import Button from 'components/commons/buttons/button/Button';
import { useResetPwdNoLoggedUserInitMutation } from 'redux/services/userService';
import { userState } from 'redux/slices/userSlice';
import './modalNewPassword.scss';
import { useSelector } from 'react-redux';
import { useTranslate } from 'context/languageContext';

export default function ModalNewPassword({ onClose }) {
  const account = useSelector(userState);
  const t = useTranslate();

  const [sent, setSent] = useState(false);
  const [email, setEmail] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [resetPwdNoLoggedUserInit] = useResetPwdNoLoggedUserInitMutation();

  const handleSendResetPwd = async () => {
    await resetPwdNoLoggedUserInit({ body: { email: email }, token: account.bearerToken }).then(
      (res: any) => {
        if (res?.error) {
          setErrorMsg('Email invalido');
          setTimeout(() => {
            setErrorMsg('');
          }, 3000);
        } else {
          setSent(true);
        }
      },
    );
  };

  return (
    <>
      {!sent && (
        <ModalInfo closeAction={onClose} width='350px' height='max-content'>
          <div className='modal-new-password'>
            <h3>{t('lb_configuracion_necesitas_contrasena_nueva')}</h3>
            <div className='modal-new-password-text'>
              {t('lb_configuracion_necesitas_contrasena_nueva_text')}
            </div>

            <SearchInput
              name='modal-pwd-input'
              placeholder='Correo electrónico'
              className='modal-new-password-input'
              actionOnChange={(e) => setEmail(e)}
            />

            <div className='modal-new-password-actions'>
              {errorMsg && (
                <div className='error-new-pwd-msg'>
                  <span>{errorMsg}</span>
                </div>
              )}

              <Button
                title='Enviar'
                className={`modal-new-password-btn-aceptar ${!email && '--disabled'}`}
                onClick={() => handleSendResetPwd()}
                disabled={!email ? true : false}
              />
            </div>
          </div>
        </ModalInfo>
      )}
      {sent && (
        <ModalInfo closeAction={() => onClose()} width='300px' height='max-content'>
          <div className='modal-new-password'>
            <h3 style={{ margin: '0px' }}>{'Se ha enviado un correo electrónico'}</h3>
            <div className='modal-new-password-text'>
              {t('lb_configuracion_revisa_bandeja_correo')}
            </div>

            <div className='modal-new-password-actions'>
              <Button
                title={t('lb_aceptar')}
                className={`modal-new-password-btn-aceptar ${!email && '--disabled'}`}
                onClick={() => onClose()}
              />
            </div>
          </div>
        </ModalInfo>
      )}
    </>
  );
}
